import Form from '../module/Form';

// form関連
new Form();



// WEBPACK FOOTER //
// ./src/js/entry/form.js